import { useMe } from '@scout/identity'
import { SidebarAccount } from '@scout/ui/sidebar'

import { SignIn } from './SignIn'
import { SignOut } from './SignOut'

/**
 * The sidebar's account area: who you are, or the way in.
 *
 * Three states rather than two. While identity is unsettled this renders
 * nothing at all, because the two faces it can wear say opposite things — "sign
 * in" and "you are signed in as…" — and showing the wrong one for a moment on
 * every page load reads as the app losing track of who you are.
 *
 * What names someone is their own name, falling back to the address the
 * boundary attests. Never the other way round: the boundary attests no name,
 * and what a person calls themselves is the thing they told us.
 */
export function Identity() {
  const who = useMe()

  if (!who.settled) return null
  if (who.person === null) return <SignIn />

  // Both handed over rather than collapsed here. The precedence between them —
  // a person's own name, falling back to the address the boundary attests — is
  // one rule, and the avatar needs both to draw initials from. This used to
  // reduce them to one string, which left the console passing an address and
  // the shared component with no way to tell which it had been given.
  return (
    <SidebarAccount
      name={who.person.name}
      email={who.person.identity.email}
      organisation={who.person.buyer_name}
    >
      <SignOut />
    </SidebarAccount>
  )
}
